import React from "react"
import { Container,Row,Col } from 'react-bootstrap'
import Head from "../components/head"
import Products from "../components/products"
import Layout from "../components/layout"
import 'bootstrap/dist/css/bootstrap.min.css'
import $ from "jquery"
import {
	FacebookShareButton,
	FacebookIcon,
	TwitterShareButton,
	TwitterIcon,
	LineShareButton,
	LineIcon,
  } from 'react-share';
  
	
  class Index extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			url : props.location.href
		};
	}

	componentDidMount(){
		
		/*
		$(function(){

			$("source").each(function(){
				let imgPath = $(this).attr("srcset");
				if(imgPath.match(/^\/static\//)){
					let newImgPath = "/LP/kawamura-lp/"+imgPath
					$(this).attr("srcset",newImgPath);
					console.log("DONE");
				}

			});

		});
		*/

	}

	render(){
	return(
		<Layout>

			<Head
				title = "河村勇輝出演DVD | 福岡第一高校のバスケットボール練習方法"
				keywords = "河村勇輝,福岡第一高校バスケットボール部"
				description = "福岡第一高校で取り組まれている「ガード育成」に特化した練習法を紹介。 河村勇輝選手、小川選手を中心とした才能あふれるガード陣を更なる高みへと引き上げた、井手口先生がこだわり続ける「ガード育成」をぜひご覧ください。"
				type = "website"
				url = "https://www.japanlaim.com/LP/kawamura-lp/"
			/>

			<div className="SNS">
				<Container>
					<Row>
						<Col>
							<FacebookShareButton url={this.state.url} className="mr-2">
							<FacebookIcon size={60} round />
							</FacebookShareButton>
							<TwitterShareButton url={this.state.url} className="mr-2">
							<TwitterIcon size={60} round />
							</TwitterShareButton>
							<LineShareButton url={this.state.url} className="mr-2">
							<LineIcon size={60} round />
							</LineShareButton>
						</Col>
					</Row>
				</Container>
			</div>

			<div className="CatchPhrase">
				<Container>
					<Row>
						<Col>
							<h2>ここでしか見られないプレーや練習法から、上達のヒントを学べる</h2>
							<p className="Products Product__Detail Product__Detail_Type_Other">
								本作では、福岡第一高校で取り組まれている「ガード育成」に特化した練習法を紹介。
								河村選手を中心とした才能あふれるガード陣を更なる高みへと引き上げた、
								井手口先生がこだわり続ける「ガード育成」をぜひご覧ください！
							</p>
						</Col>
					</Row>
				</Container>
			</div>

			<div className="TitleBox">
				<Container>
					<Row>
						<Col>
							<p className="TitleBox TitleBox__Title"><span>２種のDVDから選ぶ</span></p>
							<p className="TitleBox TitleBox__Desc">
								この二つの作品は、重複した内容が含まれていますのでご注意ください。<br/>
								※「ブレイク」と「個人スキル」は同じ内容です。<br/>
								ご購入の際は、商品詳細をご覧になっていただくことをお勧めします。
							</p>
						</Col>
					</Row>
				</Container>
			</div>

			<Products />

		</Layout>
	)
	}

}

export default Index
